"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cerris = void 0;
var internal_1 = require("./internal");
exports.cerris = {
    impressum: "".concat(internal_1.contentBucketUrl, "/cerris/legal/impressum.pdf"),
    declarationOfDataProtection: "".concat(internal_1.contentBucketUrl, "/cerris/legal/declaration-of-data-protection.pdf"),
    termsOfService: "".concat(internal_1.contentBucketUrl, "/cerris/legal/terms-of-service.pdf"),
    datenschutzerklaerung: "".concat(internal_1.contentBucketUrl, "/cerris/legal/datenschutzerklaerung.pdf"),
};
